import script from "./LeftSidebarComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftSidebarComponent.vue?vue&type=script&setup=true&lang=js"

import "./LeftSidebarComponent.vue?vue&type=style&index=0&id=76a8ed19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76a8ed19"]])

export default __exports__